<template>
    <div class="container section">
        <div class="row heading">
            <div class="col">
                <h2>Locations</h2>
            </div>
            <div class="col">
                <paginate
                        :page-count="num_pages"
                        :initial-page="paginate.current_page-1"
                        :page-range="1"
                        :margin-pages="1"
                        :click-handler="paginateClick"
                        container-class="pagination"
                        page-class="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                ></paginate>
            </div>
        </div>

        <div class="row lined carrier-details">
            <div class="col-12">Carriers servicing these locations (click to show detail)</div>

            <div v-for="(carrier, carrier_id) in carriers" class="btn " :class="{'btn-primary': activeCarrier == carrier.carrier_id, 'btn-download': activeCarrier != carrier.carrier_id  }" style="margin: 5px;" @click="setActiveCarrier(carrier.carrier_id); clearRows();">
                <div>{{carrier.carrierName}} ({{carrier.count}})</div>
            </div>
        </div>

        <div class="row table-head" >
            <div class="col-5">Address</div>
            <div class="col-4 text-center" v-show="activeCarrier">Carrier Detail</div>

        </div>



        <div class="row lined" v-for="l, i in leadLocations" :key="l.leadLocation_id">

            <div class="col-5">
                <button class="btn btn-clear" @click="setShowLocationCarriers(l.leadLocation_id)">{{l.location.formatted_address}}</button>
            </div>

            <div class="col-5 text-center">
                <span  v-show="activeCarrier">
                    {{ carrierDetails(l.carriers).carrierField1 || '-'  }} | {{ carrierDetails(l.carriers).carrierField2 || '-'  }}
                </span>
            </div>

            <div class="col-2 text-right">
                <dropdown-confirmation
                        title="Are you sure you want to delete this location?"
                        @confirm="deleteLocation(l)"></dropdown-confirmation>
            </div>
            <div class="col-12 carrier-details" v-for="c in l.carriers" v-show="showLocationCarriers.indexOf(l.leadLocation_id) >= 0">
               <div class="container">
                   <div class="row">
                       <div class="col-5"> {{c.carrierName}}</div>
                       <div class="col-4"> {{c.carrierField1 || '-'}} | {{c.carrierField2 || '-'}}</div>
                       <div class="col-3 text-right">

                           <button v-show="!c.is_quoted" class="btn btn-white btn-sm" @click="quoteCarrier(c.carrier_id)">
                               <span v-show="!carrier_loading || carrier_loading != c.carrier_id"><i class="fa fa-plus"></i>&nbsp;&nbsp;Quote</span>
                               <span v-show="carrier_loading == c.carrier_id">
                                   <i class="fa fa-spin fa-circle-o-notch"></i>
                               </span>
                           </button>


                       </div>
                   </div>
               </div>
            </div>
        </div>


        <div class="row lined">
            <div class="col" v-show="!showAddLocation">
                <button class="btn btn-primary" @click="showAddLocation = true;" ><i class="fa fa-plus"></i> &nbsp;Add Location</button>
            </div>

            <div class="col-6" v-show="showAddLocation">
                <google-address-searcher :selected="address" @input="addAddress"></google-address-searcher>
            </div>
            <div class="col-6" v-show="showAddLocation">
                <button class="btn btn-clear" @click="resetAddress" >Cancel</button>
                <button class="btn btn-primary" @click.prevent="addLocation"><i class="fa fa-plus"></i> &nbsp;Save Address</button>
                <loading v-show="isLoading" style="float:right;" color="#5e9cd3" size="10px"> </loading>
            </div>
        </div>

    </div>
</template>
<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import GoogleAddressSearcher from '../assets/GoogleAddressSearcher.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Loading from 'vue-spinner/src/PulseLoader.vue';

    export default {
        name: 'Notes',
        data: function(){
            return {
                showLocationCarriers: [],
                carrier_loading: null,
                params: {
                    data: {
                        lead_id: ''
                    }
                },
                address: {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    lat:'',
                    lng:'',
                    neighborhood: '',
                    formatted_address: ''
                },
                num_pages: 0,
                paginate:{
                    current_page: 1,
                    limit: 5,
                    offset:0
                },
                selected: {
                    leadLocation_id: '',
                    location: {},
                },
                showAddLocation: false,
                leadLocations:[],
                isLoading: false,
                carriers: {},
                activeCarrier: null,
                loading: false

            }
        },
        components:{
            Paginate,
            DropdownConfirmation,
            Loading,
            GoogleAddressSearcher
        },
        created(){
            this.fetchLeadLocations();
        },
        computed:{

        },
        filters:{
            formatDate(date){
                return moment(date).format('MM/DD/YYYY hh:mm:ss a');
            }

        },
        methods:{
            setShowLocationCarriers(lead_location_id){
                this.activeCarrier = null;
                if(this.showLocationCarriers.indexOf(lead_location_id) >= 0 ){
                    this.showLocationCarriers.splice(this.showLocationCarriers.indexOf(lead_location_id), 1);
                    return;
                }
                this.showLocationCarriers.push(lead_location_id);
            },
            quoteCarrier(carrier_id){
                if(!this.carrier_loading){
                    this.carrier_loading = carrier_id;

                    this.$send(this, 'leadCarrierCreate',{
                        carrier_id: carrier_id,
                        lead_id: this.lead_id
                    }).then(r => {
                        this.carrier_loading = false;
                        this.fetchLeadLocations();
                        this.$emit('leadCarrierUpdate');
                    });
                }
            },
            clearRows(){

                this.leadLocations.map(l => {
                    l.active = false;
                })
            },
            carrierDetails(carriers){
                carriers = carriers || [];
                if(!carriers.length) return ' - ';

                var activeCarrier = carriers.filter(c =>  c.carrier_id == this.activeCarrier );

                if(!activeCarrier.length) return ' - ';
                return activeCarrier[0];

            },

            setActiveCarrier(carrier_id){
                if(!this.activeCarrier || this.activeCarrier != carrier_id){
                    this.activeCarrier = carrier_id;
                } else {
                    this.activeCarrier = null;

                }
            },
            addAddress(address){
                if(address.formatted_address){
                    this.address = address;
                }
            },
            addLocation(){
                if(!this.isLoading){

                    this.isLoading = true;

                    var data = {
                        lead_id: this.lead_id,
                        location: this.address
                    };

                    this.$send(this, 'leadLocationCreate', data).then(r => {
                        this.isLoading = false;
                        this.resetAddress();
                        this.fetchLeadLocations();
                    });

                }

            },
            resetAddress(){
                this.address = {
                    address: '',
                        city: '',
                        state: '',
                        zip: '',
                        lat:'',
                        lng:'',
                        neighborhood: '',
                        formatted_address: ''
                };
                this.showAddLocation = false;
            },
            deleteLocation(selected){
                this.$send(this, 'leadLocationDelete', selected).then(r => {
                    this.fetchLeadLocations();
                });
            },
            paginateClick(pageNum){
                this.paginate.current_page = pageNum;
                this.fetchLeadLocations();
            },
            fetchLeadLocations(){
                var data = {};
                data.lead_id = this.lead_id;
                data.offset = this.paginate.limit * (this.paginate.current_page - 1);
                data.limit = this.paginate.limit;

                // this.timer = moment().valueOf();
                // data.time = this.timer;
                this.$send(this, 'leadLocations', data).then(r => {
                    this.leadLocations = r.leadLocations;
                    this.num_pages = Math.ceil(r.count / this.paginate.limit);
                    this.leadLocations.forEach(l => {

                        this.$set(l, 'active', false);

                        l.carriers.forEach(c => {
                            console.log(this.carriers);
                            this.carriers['carrier_' + c.carrier_id] = this.carriers['carrier_' + c.carrier_id] || { carrierName: c.carrierName, count: 0, carrier_id: c.carrier_id };
                            this.carriers['carrier_' + c.carrier_id].count++;
                        })
                    })

                });

            },
        },
        props:{
            lead_id:{

            }

        }

    }

</script>
<style scoped>
    .carrier-details{
        background-color: #e3eaf1;
        color: #325482;
        border-radius: 2px;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// LeadLocations.vue?32d88426